import React, { ButtonHTMLAttributes, FC } from 'react';
import classnames from 'classnames';
import styles from './Button.module.scss';
import { FaPrefix } from '../FaIcon/FaIcon';

export type Variant = 'primary' | 'ghost' | 'secondary' | 'none';

export type Color = 'red' | 'dark' | 'blue' | 'dark-blue';

export interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  component?: any;
  variant?: Variant;
  color?: Color;
  inline?: boolean;
  bold?: boolean;
  medium?: boolean;
  to?: string;
  activeClassName?: string;
  disabled?: boolean;
  exact?: boolean;
  icon?: string;
  iconPrefix?: FaPrefix;
}

const Button: FC<IButtonProps> = (props) => {
  const {
    component: Component = 'button',
    className,
    variant = 'primary',
    color = 'red',
    inline,
    children,
    bold,
    medium,
    icon,
    iconPrefix = 'fas',
    onClick = () => {},
    ...otherProps
  } = props;

  const rootClassName = classnames(styles.root, className, {
    [styles.ghost]: variant === 'ghost',
    [styles.primary]: variant === 'primary',
    [styles.secondary]: variant === 'secondary',
    [styles.red]: color === 'red',
    [styles.dark]: color === 'dark',
    [styles.blue]: color === 'blue',
    [styles.darkBlue]: color === 'dark-blue',
    [styles.inline]: inline,
    [styles.bold]: bold,
    [styles.medium]: medium,
  });

  return (
    <Component className={rootClassName} onClick={onClick} {...otherProps}>
      {icon && <span className={`${iconPrefix} fa-${icon} mr-2`} />}
      {children}
    </Component>
  );
};

export default Button;
